export default {
    // MEMO：サービス別に書き換える
    service_type: "portal",
    maintitle: "F-Portal",
    basepath: "",
    basecolor: {
        base: "#1976D2",   // blue darken-2
        text: "#1976D2",
        background: "#ffffff",
        container_background: "#F8F5F5",
        isdark: false,
        input: "teal lighten-1",
        shop_share_mode: "#ffc65c"
    },
    menus: {
        home: {
            name: "ホーム",
            to: "/",
        },
        master: {
            name: "データ管理",
            role_cds: ["admin", "officer", "manager"],
        },
        // file: {
        //   name: "ファイル",
        //   to: "/file",
        //   role_cds: ["admin", "officer", "manager"],
        // },
        menus: {
            name: "メニュー",
            to: "/setting/menu",
            sublinks: [
                {
                    name: "アカウント",
                    linked_path: "/account",
                },
                {
                    name: "すべてのサービス",
                    linked_path: "/myapp",
                },
                {
                    name: "連携サービス",
                    linked_path: "/linked_services",
                },
                // {
                //   name: "招待",
                //   linked_path: "/invitation",
                //   policy: { function_cd: "invite", crud: ['c', 'r', 'u', 'd'] }
                // },
                {
                    name: "ヘルプセンター",
                    linked_path: "/help",
                    external_browser_only: true,
                    // target: "_help"
                },
                {
                    name: "アプリについて",
                    linked_path: "/about",
                },
            ]
        }
    }
}